import AppPagination from "../../app/components/AppPagination";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import {
  entrezDbSelectors,
  updateSelectedDBState,
} from "../../app/store/entrezDbSlice";

import DBTableView from "./DBTableView";

export default function EntrezTableWithPaginationTopBottom() {
  const { dbParams } = useAppSelector((state) => state.entrezDb);

  const dispatch = useAppDispatch();

  //dbParams.db must be set before reaching here.
  const selectedDbWithItsState = useAppSelector((state) =>
    entrezDbSelectors.selectById(state, dbParams.db)
  );

  const handlePageNumberChange = (page: number) => {
    if (selectedDbWithItsState === undefined) return;

    console.log(page);
    console.log(selectedDbWithItsState!.paginationData.pageSize);

    // var pageData = {
    //   currentPage: page,
    //   // retstart: (page - 1) * selectedDbWithItsState!.paginationData?.pageSize!,
    // };

    var updatedPaginationData = {
      ...selectedDbWithItsState!.paginationData,
      currentPage: page,
    };

    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          paginationData: updatedPaginationData,
          isReadyForFetch: true,
        },
      })
    );
  };

  const handlePageSizeChange = (pageSize: number) => {
    if (pageSize <= 1) return;
    console.log("handlePageSizeChange");
    console.log(pageSize);

    var updatedPaginationData = {
      currentPage: 1,
      totalPages: Math.ceil(
        selectedDbWithItsState!.paginationData?.totalCount! / pageSize
      ),
      pageSize: pageSize,
      totalCount:selectedDbWithItsState!.paginationData?.totalCount
    };

    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          paginationData: updatedPaginationData,
          isReadyForFetch: true,
        },
      })
    );
  };

  const handleApplySelectedColumns = (selectedCols: string[]) => {
    console.log("Entrez page:");
    console.log(selectedCols);
    // dispatch(setSelectedColumns({ selectedColumns: selectedCols }));

    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          selectedColumns: selectedCols,
        },
      })
    );
  };

  //just columns:
  const columns = selectedDbWithItsState?.dbRecords
    ? selectedDbWithItsState!.dbRecords.dbColumns.map((col) => col.Header)
    : [];

  //selected columns , by default show - 7  , otherwise selected columns
  const selColsORFirst6 =
    (!selectedDbWithItsState ||
    !selectedDbWithItsState.selectedColumns ||
    selectedDbWithItsState.selectedColumns.length === 0)

      ? columns.slice(0, 7) 
      : selectedDbWithItsState.selectedColumns;

  console.log(selColsORFirst6);

  return (
    <>
      {/* Displaying on top of table */}
      {console.log(selectedDbWithItsState?.paginationData)}
      {selectedDbWithItsState!.paginationData && (
        <AppPagination
          paginationData={selectedDbWithItsState!.paginationData}
          allColumns={columns}
          selectedColumns={selColsORFirst6}
          dataRecords={selectedDbWithItsState!.dbRecords?.dbRows}
          selectedDB={dbParams.db}
          onPageChange={handlePageNumberChange}
          onPageSizeChange={handlePageSizeChange}
          onApplySelectedColumns={handleApplySelectedColumns}
        ></AppPagination>
      )}
      <DBTableView
        dbRecords={selectedDbWithItsState!.dbRecords}
        selectedDB={dbParams.db}
        selectedColumns={selColsORFirst6}
      ></DBTableView>
      {/* Displaying below the table */}
      {selectedDbWithItsState!.dbRecords &&
        selectedDbWithItsState!.dbRecords.dbRows.length > 10 && (
          <AppPagination
            paginationData={selectedDbWithItsState!.paginationData}
            allColumns={columns}
            selectedColumns={selColsORFirst6}
            dataRecords={selectedDbWithItsState!.dbRecords?.dbRows}
            selectedDB={dbParams.db}
            onPageChange={handlePageNumberChange}
            onPageSizeChange={handlePageSizeChange}
            onApplySelectedColumns={handleApplySelectedColumns}
          ></AppPagination>
        )}
    </>
  );
}
